export default __webpack_public_path__ + "static/media/check.546e4e84.png";